<!-- mall/src/views/user-center/bind-card-success.vue -->

<template>
  <div>
    <van-empty description="卡券领取成功, 请关闭本页面, 扫码兑换" />

    <div style="display: flex; justify-content: space-between; padding-left: 10vw; padding-right: 10vw;">
      <van-button round @click="goBack" style="width: 100px;">返回</van-button>
      <van-button round @click="goKefu" style="width: 100px;">客服</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "bind-card-success",

  methods: {
    goKefu() {
      location.href = "/v4/Kefu"
    },

    goBack() {
      history.go(-2) // -1 是 card-mobile-bind 页
    }
  }
}
</script>
